import { create } from "zustand";

interface RoleStore {
  role: string | undefined;
  setRole: (user: string ) => void;
}

export const useRoleStore = create<RoleStore>((set) => ({
  role: undefined,
  setRole: (role: string ) => set({ role }),
}));
